import { map, some } from 'lodash';
import React from 'react'
import { Offcanvas, Accordion } from 'react-bootstrap';
import VulnerabilityAccordion from './VulnerabilityAccordion';

const VulnerabilitiesModal = ({ deviceIP, vulnerabilities, show, setShow, vulnerabilitiesCount }) => {

  return (
    <Offcanvas show={show} onHide={() => setShow(null)} placement='end' style={{ width: '50%' }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title as="h1" className="flex items-center pl-4">
        <span className="text-4xl font-light pr-3.5 border-r border-slate-300 mr-3 text-blue-800">{deviceIP}</span>
          In total: {vulnerabilitiesCount} Vulnerabilities
        </Offcanvas.Title>
      </Offcanvas.Header>
      <hr className='m-auto' style={{ width: "95%" }}/>
      <Offcanvas.Body>
        {some(vulnerabilities) && (<VulnerabilityAccordion vulnerabilities={vulnerabilities} />)}
      </Offcanvas.Body>
  </Offcanvas>
  )
}

export default VulnerabilitiesModal